import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody36';
import Footer from '../component/Footer'
import { Helmet } from 'react-helmet';

const CaseStudy36 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'>Financial Due Diligence </h2><h4>for a GP-led secondaries sale</h4>";

  return (
    <>
        <Helmet>
        <title>Financial Due Diligence for a GP-led secondaries sale</title>
        <meta property="og:title" content="Financial Due Diligence for a GP-led secondaries sale" />
        <meta property='og:description' content='Financial Due Diligence for a GP-led secondaries sale'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy36" headings={headings} />  
        <Casestudybody />
        <Footer setBlank={setBlank} />
    </>
  )
}

export default CaseStudy36 
